module.exports = __webpack_public_path__ + "static/media/white-plus-icon.c689c833.svg";